/* eslint-disable */
import { Card } from '@material-ui/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import showAlert from '../../utils/alert';
import { normalizeCrewList } from '../../utils/formatCrewDisplay';
import { enrichCrewListWithSapBP } from '../../utils/enrichCrewWithSapBP';
import Footer from '../common/Footer';
import Header from '../common/Header';
import POForm from './POForm';
import { getPOQuery } from './queries/getPO';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';

const initialData = {
  vendorId: '',
  companyId: null,
  address: '',
  currencyId: 1,
  expenseCategoryId: '',
  accountCode: '',
  dateOfService: [],
  levelOnePurpose: '',
  levelTwoPurpose: '',
  budgetCategory: '',
  purchaseOrderCrew: [
    {
      crewId: '',
      accountCode:'',
      expenseLineItemId: '',
      plannedVesselId: '',
      amount: '',
      crewCode: '',
      ppeDeliveryRemarks: '',
      id: '',
      ppeCategoryDetails:[], 
      plannedVesselRevisionId:''
    }
  ]
};

const CreatePO = ({ mode }) => {
  const [isLoading, setisLoading] = useState(true);
  const [isDraft, setDraft] = useState(false);
  const [isFetchingPo, setisFetchingPo] = useState(false);
  const history = useHistory();
  const { poId } = useParams();
  const [isduplicateloading, setisduplicateloading] = useState(false);
  const [dataObj, setdataObj] = useState(null);
  const [restoredPpeCategoryDetails, setRestoredPpeCategoryDetails] = useState({});
  const [isCrewPage, setisCrewPage] = useState();

  const policies = returnPolicies();

  useEffect(() => {
    setisCrewPage(JSON.parse(localStorage.getItem('isPageHandler')))
    if (policies?.poPolicies?.canEdit === false) {
        history.push('/');
      }
  }, [policies]);

  const createEditObject = async (filteredObj) => {
    const filteredObjCopy = JSON.parse(JSON.stringify(filteredObj));
    const restoredPpeDetails = JSON.parse(JSON.stringify(filteredObjCopy.purchaseOrderCrew[0].ppeCategoryDetails));
    const plannedVesselId = JSON.parse(JSON.stringify(filteredObjCopy.purchaseOrderCrew[0].plannedVesselId));

    setRestoredPpeCategoryDetails({ restoredPpeDetails, plannedVesselId });
    if (filteredObj) {
      const categoryDetails = filteredObj.categoryDetails?.reduce((acc, cur) => ({ ...acc, [cur.key]: cur.value }), {});
      const dateOfService = filteredObj?.dateOfService
        ?.map((item) => {
          if (item?.dateOfServices) {
            return { dateOfServices: moment(item?.dateOfServices).format('YYYY-MM-DD') };
          }
          return undefined;
        })
        .filter((i) => i);

      const normalizedCrew = normalizeCrewList(filteredObj?.purchaseOrderCrew);
      const purchaseOrderCrew = await enrichCrewListWithSapBP(normalizedCrew, {
        companyId: filteredObj?.companyId,
        expenseCategoryID: filteredObj?.expenseCategoryId || ''
      });

      setdataObj({
        ...filteredObj,
        purchaseOrderCrew,
        vendorId: filteredObj?.vendorId,
        company: filteredObj?.companyId,
        restoredPpeCategoryDetails,
        ...categoryDetails,
        dateOfService,
        levelOnePurpose: filteredObj?.purposeId,
        levelTwoPurpose: filteredObj?.purposeLevelId
      });
    }
    return null;
  };

  useEffect(() => {
    if (poId && mode === 'edit') {
      setisFetchingPo(true);
      getPOQuery(poId)
        .then(async (res) => {
          await createEditObject(res?.data);
          setisFetchingPo(false);
        })
        .catch((err) => {
          setisFetchingPo(false);
          showAlert('Something went wrong', 'error');
        });
    }
    if (mode === 'add') {
      setdataObj(initialData);
      setRestoredPpeCategoryDetails({restoredPpeDetails:[],plannedVesselId:''})
    }
  }, [poId, mode]);

  const handleCancel = () => {
    if (poId && mode === 'edit') {
      history.push(`/po/${poId}`);
    } else {
      history.push('/');
    }
  };
  return (
    <div className="md:w-full">
      <Header
        parentPageLink="/"
        currentPage={`${mode === 'add' ? 'Create' : 'Edit'} Purchase Order`}
        parentPage="Purchase Order List"
        headerName="Purchase Orders"
      />
      {/* Form */}
      <Card className="h-full overflow-visible-custom mx-12" variant="Header">
        <div className="px-12">
          <POForm {...{ isDraft, setDraft, dataObj, setisLoading, setisduplicateloading, mode, isFetchingPo,restoredPpeCategoryDetails,setRestoredPpeCategoryDetails }} />
        </div>
      </Card>
     <Footer {...{ isLoading, handleCancel, isduplicateloading, setDraft, mode, dataFail: dataObj?.isSyncFailure,isCrewPage}} isdraftButton />
    </div>
  );
};

export default CreatePO;
